import { Building2, Clock, MapPin } from "lucide-react";

export default function ProgramInfoBar() {
  return (
    <section
      className="
        relative z-20
        -mt-8 sm:-mt-10 md:-mt-12
        px-4 sm:px-6 md:px-12 lg:px-12
      "
    >
      <div className="container mx-auto">
        <div
          className="
            bg-white/90 backdrop-blur-xl rounded-2xl
            shadow-[0_30px_80px_rgba(2,8,23,0.18)]
            p-6 sm:p-8 md:p-10
            max-w-6xl mx-auto
            border-t-4 border-[#0E6F7E]
          "
        >
          <div
            className="
              grid grid-cols-1 md:grid-cols-3
              gap-6 sm:gap-8 md:gap-14
            "
          >
            {/* Organized by */}
            <div className="flex items-start gap-4 group">
              <div
                className="
                  flex-shrink-0
                  w-10 h-10 sm:w-12 sm:h-12
                  rounded-full
                  bg-gradient-to-br from-[#07162E] via-[#0B2A4A] to-[#0E6F7E]
                  flex items-center justify-center
                  group-hover:scale-110 transition-transform duration-300
                "
              >
                <Building2 className="w-5 h-5 sm:w-6 sm:h-6 text-[#1DBF73]" />
              </div>
              <div>
                <p className="text-xs text-gray-500 font-semibold uppercase tracking-wider">
                  Organized by
                </p>
                <p className="text-base sm:text-lg font-semibold text-[#07162E] mt-1">
                  AQT Direct Limited
                </p>
              </div>
            </div>

            {/* Program Time */}
            <div className="flex items-start gap-4 group">
              <div
                className="
                  flex-shrink-0
                  w-10 h-10 sm:w-12 sm:h-12
                  rounded-full
                  bg-gradient-to-br from-[#07162E] via-[#0B2A4A] to-[#0E6F7E]
                  flex items-center justify-center
                  group-hover:scale-110 transition-transform duration-300
                "
              >
                <Clock className="w-5 h-5 sm:w-6 sm:h-6 text-[#1DBF73]" />
              </div>
              <div>
                <p className="text-xs text-gray-500 font-semibold uppercase tracking-wider">
                  Program Time
                </p>
                <p className="text-base sm:text-lg font-semibold text-[#07162E] mt-1">
                  9:00 AM – 1:00 PM
                </p>
              </div>
            </div>

            {/* Venue */}
            <div className="flex items-start gap-4 group">
              <div
                className="
                  flex-shrink-0
                  w-10 h-10 sm:w-12 sm:h-12
                  rounded-full
                  bg-gradient-to-br from-[#07162E] via-[#0B2A4A] to-[#0E6F7E]
                  flex items-center justify-center
                  group-hover:scale-110 transition-transform duration-300
                "
              >
                <MapPin className="w-5 h-5 sm:w-6 sm:h-6 text-[#1DBF73]" />
              </div>
              <div>
                <p className="text-xs text-gray-500 font-semibold uppercase tracking-wider">
                  Venue
                </p>
                <p className="text-base sm:text-lg font-semibold text-[#07162E] mt-1">
                  Gurugram, India
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
